module.exports = __webpack_public_path__ + "img/p19.4042e08c.png";